import { Link } from "react-router";
import { RevueNumerique } from "../../lib/interfaces/revue-numerique.interface";
import { buttonVariants } from "../ui/button";
import { BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";

export default function RevueNumeriqueItem({ revue }: { revue: RevueNumerique }) {
  return (
    <article className="flex flex-col gap-5 px-5 py-6 sm:flex-row sm:px-6">
      <div className="relative mx-auto w-28 shrink-0 sm:mx-0 sm:w-32">
        <div className="absolute -right-2 top-2 h-full w-full rounded-xl bg-[#f1e8c9]" />
        <img
          src={revue.couvertureUrl}
          alt={`Couverture de ${revue.nom}`}
          className="relative aspect-[3/4] w-full rounded-xl border border-slate-200 object-cover shadow-sm"
        />
      </div>

      <div className="flex min-w-0 flex-1 flex-col items-start sm:py-1">
        <h3 className="text-lg font-bold leading-6 text-slate-950">{revue.nom}</h3>
        <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">{revue.description}</p>

        <Link
          to={`/revue/${revue.id}`}
          className={cn(
            buttonVariants({ size: "sm" }),
            "mt-5 w-full gap-2 bg-[#173f35] hover:bg-[#23594a] sm:w-auto",
          )}
        >
          <BookOpen className="h-4 w-4" />
          Lire la revue
        </Link>
      </div>
    </article>
  );
}
